import { takeLatest, call, put } from "redux-saga/effects";

import * as types from "../actions/actionTypes";
import { DownloadFileAction, InitAction } from "../actions";
import * as DownloadFileApi from "../api/downloadFile";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherDownloadFile() {
  yield takeLatest(types.DOWNLOAD_FILE_REPORT_REQUEST, file);
  yield takeLatest(types.DOWNLOAD_FILE_CHECK_FILES_REQUEST, checkFiles);
}

function askFile(data) {
  return DownloadFileApi.askFile(data);
}

function* file(action) {
  try {
    const response = yield call(askFile, action.data);
    yield put(DownloadFileAction.reportSuccess(response.data.data));
    yield put(DownloadFileAction.checkFilesRequest());
    yield put(InitAction.getSuccess({ premium: response.data.premium }));
  } catch (error) {
    yield put(DownloadFileAction.reportFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

function checkFilesReq() {
  return DownloadFileApi.checkFiles();
}

function* checkFiles() {
  try {
    const response = yield call(checkFilesReq);
    yield put(DownloadFileAction.checkFilesSuccess(response.data.data));
  } catch (error) {}
}
